import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import API from '../services/api';
import { useEffect, useState } from 'react';
import { useMediaQuery } from '@mui/material';

export default function CustomAutoComplete({
    onChange,
    name,
    supplier = 0,
    setSupplierName,
    endpoint = 'suppliers/',
    onSelectOption,
}) {
    const [suppliers, setSuppliers] = useState([]);
    const [selectedSupplier, setSelectedSupplier] = useState(null);
    const isMobile = useMediaQuery("(max-width: 768px)");

    useEffect(() => {
        const getData = async () => {
            try {
                const response = await API.get(endpoint, { params: { active: true } });
                const items = Array.isArray(response?.data) ? response.data : [];
                setSuppliers(items);

                if (supplier) {
                    const found = items.find((s) => s.id === supplier) || null;
                    setSelectedSupplier(found);
                    if (found) {
                        onSelectOption?.(found);
                        onChange?.(name, found.id);
                        setSupplierName?.(found.companyName);
                    } else {
                        onSelectOption?.(null);
                    }
                }
            } catch (err) {
                console.error(err);
            }
        };
        getData();
    }, [endpoint, supplier]);


    const handleSelect = (event, nextSupplier) => {
        if (nextSupplier) {
            onSelectOption?.(nextSupplier);
            onChange(name, nextSupplier.id);
            setSelectedSupplier(nextSupplier);
            setSupplierName?.(nextSupplier.companyName);
            return;
        }

        setSelectedSupplier(null);
        setSupplierName?.("");
        onSelectOption?.(null);
    };

    return (
        <Autocomplete
            disablePortal
            name={name}
            options={suppliers}
            size='small'
            getOptionLabel={(option) => option.companyName}
            value={selectedSupplier}
            onChange={handleSelect}
            disabled={supplier !== 0}
            sx={{ width: isMobile ? 200 : 300, padding: "5px", marginBottom: "10px" }}
            renderInput={(params) => <TextField {...params} label="Empresa" />}
        />
    );
};
